type Permission = {
  title: string;
  value: string;
  children?: Permission[];
};

export const PERMISSIONS: Permission[] = [
  {
    title: '首页',
    value: 'dashboard',
    children: [
      {
        title: '业务统计',
        value: 'dashboard/analysis',
      },
    ],
  },
  {
    title: 'CRM',
    value: 'crm',
    children: [
      {
        value: 'crm/hotelManagement',
        title: '商户管理',
      },
      {
        value: 'crm/userManagement',
        title: '用户管理',
      },
      {
        value: 'crm/userPoint',
        title: '用户积分',
      },
      {
        value: 'crm/cityManagement',
        title: '城市管理',
      },
    ],
  },
  {
    title: '招聘管理',
    value: 'recruit',
    children: [
      {
        value: 'recruit/jobManagement',
        title: '岗位管理',
      },
      {
        title: '人才跟踪',
        value: 'recruit/talentTracking',
      },
      {
        title: '渠道管理',
        value: 'recruit/channel',
      },
    ],
  },
  {
    title: '考勤管理',
    value: 'attendance',
    children: [
      {
        title: '考勤商户管理',
        value: 'attendance/merchantManagement',
      },
      {
        title: '用户考勤记录',
        value: 'attendance/userHistory',
      },
    ],
  },
  {
    title: '财务管理',
    value: 'financial',
    children: [
      {
        title: '考勤审批',
        value: 'financial/attendanceApproval',
      },
      {
        value: 'financial/settlement',
        title: '结算统计',
      },
      {
        title: '工资提现记录',
        value: 'financial/payouts',
      },
      {
        title: '自动转账台账',
        value: 'financial/autoTransferLedger',
      },
      {
        title: '积分提现记录',
        value: 'financial/points',
      },
      {
        title: '用户余额',
        value: 'financial/balances',
      },
      {
        title: '费用监控',
        value: 'financial/monitor',
      },
      {
        title: '个税扣缴',
        value: 'financial/individualIncomeTax',
      },
    ],
  },
  {
    title: '风控管理',
    value: 'risk',
    children: [
      {
        value: 'risk/contract',
        title: '电子合同',
      },
      {
        value: 'risk/insurance',
        title: '商业意外险',
      },
      {
        value: 'risk/individualIncomeTax',
        title: '个税扣缴',
      },
    ],
  },
  {
    title: '系统管理',
    value: 'system',
    children: [
      {
        value: 'system/user',
        title: '用户管理',
      },
      {
        value: 'system/payoutConfig',
        title: '自动发放配置',
      },
      {
        value: 'system/role',
        title: '角色管理',
      },
      {
        title: '自定义设置',
        value: 'system/setting',
        children: [
          {
            title: '数据字典',
            value: 'system/setting/dictionary',
          },
        ],
      },
      {
        title: '邀请有礼设置',
        value: 'system/invitesetting',
      },
    ],
  },
  {
    title: '企业微信工作台',
    value: 'qiweiChat',
    children: [
      {
        title: '考勤审批',
        value: 'qiweiChat/todo/approval',
      },
    ],
  },
];

// 根据权限过滤树并返回第一个不含子元素的 value，及第一个有权限的path
export const getInitPath = (permissions: string[]) => {
  // 定义一个递归方法来过滤树
  function filterTree(node: Permission): Permission | null {
    // 如果当前节点的 value 不在 values 数组中，直接返回 null（过滤掉）
    if (!permissions.includes(node.value)) {
      return null;
    }

    // 如果当前节点有子节点，则递归过滤子节点
    if (node.children && node.children.length > 0) {
      const filteredChildren: (Permission | null)[] = node.children
        .map(filterTree) // 递归过滤子节点
        .filter((child) => child !== null); // 过滤掉 null 的子节点

      // 如果过滤后还有子节点，则返回新的节点对象；否则，返回当前节点但移除子节点
      if (filteredChildren.length > 0) {
        return { ...node, children: filteredChildren as Permission[] };
      } else {
        return { ...node, children: [] };
      }
    }

    // 如果没有子节点且本身的 value 在 values 中，则直接返回节点
    return node;
  }

  // 过滤整个树
  const filteredTree = PERMISSIONS.map(filterTree) // 过滤每个顶层节点
    .filter((node) => node !== null) as Permission[]; // 过滤掉 null 的节点

  console.log(filteredTree);

  // 定义一个方法来获取第一个不含子元素的 value
  function getFirstLeafValue(nodes: Permission[]): string | null {
    for (const node of nodes) {
      // 如果没有子节点，返回当前节点的 value
      if (!node.children || node.children.length === 0) {
        return node.value;
      }
      // 如果有子节点，递归查找第一个不含子节点的 value
      const leafValue: string | null = getFirstLeafValue(node.children);
      if (leafValue) {
        return leafValue;
      }
    }
    return null; // 如果没有找到叶子节点，返回 null
  }

  // 获取第一个不含子节点的 value
  const firstLeafValue = getFirstLeafValue(filteredTree);

  return firstLeafValue ? `/${firstLeafValue}` : null;
};
